import { SVGProps } from 'react';

export type UnfoldMoreOutlinedIconProps = SVGProps<SVGSVGElement> & {
  color?: string;
  fill?: string;
};

export const UnfoldMoreOutlinedIcon = ({ color = '#646464', ...props }: UnfoldMoreOutlinedIconProps) => (
  <svg data-e2e="unfold-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.99999 4.85833L12.6417 7.5L13.8167 6.325L9.99999 2.5L6.17499 6.325L7.35832 7.5L9.99999 4.85833ZM9.99999 15.1417L7.35832 12.5L6.18332 13.675L9.99999 17.5L13.825 13.675L12.6417 12.5L9.99999 15.1417Z"
      fill={color}
    />
  </svg>
);
